module.exports = __webpack_public_path__ + "img/british-indian-ocean-territory.132d427f.svg";